import { render, staticRenderFns } from "./BackLogin.vue?vue&type=template&id=bd930f88&scoped=true"
import script from "./BackLogin.vue?vue&type=script&lang=js"
export * from "./BackLogin.vue?vue&type=script&lang=js"
import style0 from "./BackLogin.vue?vue&type=style&index=0&id=bd930f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd930f88",
  null
  
)

export default component.exports